import React, { useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ClipLoader from "react-spinners/ClipLoader";
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

import styles from "./CRM_Main_Page.module.css";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ArrowRightSharpIcon from "@mui/icons-material/ArrowRightSharp";

import { getCRMData } from "../env/APIManager";

import DataTable from "./DataTable";

function CRM_Main_Page() {
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState([]);
	const [nextPageToken, setNextPageToken] = useState("");
	const [prevPageToken, setPrevPageToken] = useState("");
	const [currentPageToken, setCurrentPageToken] = useState("");
	const [hasNextPage, setHasNextPage] = useState(false);
	const [hasPrevPage, setHasPrevPage] = useState(false);
	const [token, setToken] = useState("");
	const [showActionBtn, setShowActionBtn] = useState(false);

	const [isOptionsOpen, setIsOptionsOpen] = useState(false);

	const [selected, setSelected] = useState("");

	let history = useHistory();

	const search = window.location.search;
	const params = new URLSearchParams(search);

	const key = params.get("key");
	const nextToken = params.get("nextPageToken");
	const savedKey = localStorage.getItem("key");

	useEffect(() => {
		let token =
			localStorage.getItem("token") == null ||
			localStorage.getItem("token") === undefined ||
			localStorage.getItem("token") === ""
				? ""
				: JSON.parse(localStorage.getItem("token"));
		setToken(token);
		if (
			currentPageToken &&
			currentPageToken !== null &&
			currentPageToken !== undefined
		) {
			fetchDataBasedOnSelected(token, "currentPageToken");
		} else {
			fetchDataBasedOnSelected(token);
		}
		localStorage.setItem("key", selected);
	}, [selected]);

	useEffect(() => {
		if (nextToken) {
			setCurrentPageToken(nextToken);
		}
		if (key && key !== null && key !== undefined && key !== "null") {
			setSelected(key);
			localStorage.setItem("key", key);

			// Clear the "url" and "nextPageToken" query parameter
			// params.delete("key");
			// params.delete("nextPageToken");
			// history.replace({ search: params.toString() });

			return;
		} else if (savedKey) {
			function checkSavedKeyForKeyword(keyword) {
				return savedKey?.includes(keyword);
			}

			// Iterate through crmContent
			for (const item of crmContent) {
				const title = item?.title;

				let foundMatch = false;

				for (const child of item.children) {
					const keyword = `${title}-${child.title}`;

					if (checkSavedKeyForKeyword(keyword)) {
						foundMatch = true;
						break;
					}
				}

				if (foundMatch) {
					setSelected(savedKey);
					break;
				} else {
					setSelected("Consumer-Orders");
					localStorage.setItem("key", "Consumer-Orders");
				}
			}
		} else {
			// Default state and save to local storage
			setSelected("Consumer-Orders");
			localStorage.setItem("key", "Consumer-Orders");
		}
	}, []);

	const handleGoBack = () => {
		history.push("/logistics/map");
	};

	const toggleOptions = () => {
		setIsOptionsOpen(!isOptionsOpen);
	};

	let crmContent = [
		{
			title: "Consumer",
			children: [{ title: "Users" }, { title: "Orders" }],
		},
		{
			title: "Merchant",
			children: [{ title: "Users" }, { title: "Tasks" }],
		},
		{
			title: "Grunner",
			children: [{ title: "Users" }, { title: "Tasks" }],
		},
		{
			title: "Business",
			children: [{ title: "Users" }, { title: "Orders" }],
		},
	];

	const handleTitleClick = (title, parentTitle, hasChildren) => {
		if (hasChildren) {
			return;
		} else {
			setNextPageToken("");
			setPrevPageToken("");
			setCurrentPageToken("");
			if (parentTitle?.length > 0) {
				setSelected(`${parentTitle}-${title}`);
				toggleOptions();
				return;
			} else {
				setSelected(title);
				toggleOptions();
			}
		}
	};
	function Entry({ entry, parentTitle = "" }) {
		const [isVisible, setIsVisible] = useState(false);

		return (
			<div>
				<div
					className={`${styles.entry} ${
						selected === `${parentTitle}-${entry.title}` ? styles.selected : ""
					}`}
					onClick={() => {
						setIsVisible(!isVisible);
						handleTitleClick(
							entry.title,
							parentTitle,
							entry.children && entry.children.length > 0
						);
					}}
				>
					{entry?.children && <ArrowRightSharpIcon />}
					{entry?.title}
				</div>

				<div>
					{isVisible && (
						<div className={styles.childEntries}>
							{entry?.children?.map((childEntry) => {
								return (
									<Entry
										entry={childEntry}
										parentTitle={entry.title}
										key={childEntry.title}
									/>
								);
							})}
						</div>
					)}
				</div>
			</div>
		);
	}

	async function handleAPIResponse(res) {
		if (res?.code === "SUCCESS") {
			setData(res?.data);
			setNextPageToken(res?.data?.nextPageToken);
			setPrevPageToken(res?.data?.prevPageToken);
			setHasNextPage(res?.data?.hasMore);
			setHasPrevPage(res?.data?.hasLess);
			setLoading(false);
		} else if (res?.code === "UNAUTHORIZED") {
			localStorage.clear();
			setLoading(false);
			history.push({ pathname: "/logistics/login" });
			toast.error(
				"You have been logged out. This may have been caused by using more than one device or browser"
			);
		} else {
			toast.error("Something went wrong, please try again later");
			setLoading(false);
			setData([]);
		}
	}

	const fetchDataBasedOnSelected = async (token, string) => {
		let url;
		let data;
		try {
			setLoading(true);
			switch (selected) {
				case "Consumer-Users":
					if (string === "next") {
						url = `consumer/users/all?nextToken=${nextPageToken}`;
					} else if (string === "prev") {
						url = `consumer/users/all?prevToken=${prevPageToken}`;
					} else if (string === "currentPageToken") {
						url = `consumer/users/all?currentToken=${currentPageToken}`;
					} else {
						url = `consumer/users/all`;
					}

					data = await getCRMData(token, url);

					await handleAPIResponse(data, selected);
					setShowActionBtn(true);

					break;

				case "Consumer-Orders":
					if (string === "next") {
						url = `orders/consumer/all?nextToken=${nextPageToken}`;
					} else if (string === "prev") {
						url = `orders/consumer/all?prevToken=${prevPageToken}`;
					} else if (string === "currentPageToken") {
						url = `orders/consumer/all?currentToken=${currentPageToken}`;
					} else {
						url = `orders/consumer/all `;
					}

					data = await getCRMData(token, url);

					await handleAPIResponse(data, selected);
					setShowActionBtn(true);

					break;
				case "Merchant-Users":
					if (string === "next") {
						url = `merchant/users/all?nextToken=${nextPageToken}`;
					} else if (string === "prev") {
						url = `merchant/users/all?prevToken=${prevPageToken}`;
					} else if (string === "currentPageToken") {
						url = `merchant/users/all?currentToken=${currentPageToken}`;
					} else {
						url = `merchant/users/all`;
					}

					data = await getCRMData(token, url);

					await handleAPIResponse(data, selected);
					setShowActionBtn(false);

					break;
				case "Merchant-Tasks":
					if (string === "next") {
						url = `merchant/tasks/all?nextToken=${nextPageToken}`;
					} else if (string === "prev") {
						url = `merchant/tasks/all?prevToken=${prevPageToken}`;
					} else if (string === "currentPageToken") {
						url = `merchant/tasks/all?currentToken=${currentPageToken}`;
					} else {
						url = `merchant/tasks/all`;
					}

					data = await getCRMData(token, url);

					await handleAPIResponse(data, selected);
					setShowActionBtn(true);

					break;
				case "Grunner-Users":
					if (string === "next") {
						url = `grunner/users/all?nextToken=${nextPageToken}`;
					} else if (string === "prev") {
						url = `grunner/users/all?prevToken=${prevPageToken}`;
					} else if (string === "currentPageToken") {
						url = `grunner/users/all?currentToken=${currentPageToken}`;
					} else {
						url = `grunner/users/all`;
					}

					data = await getCRMData(token, url);

					await handleAPIResponse(data, selected);
					setShowActionBtn(false);

					break;
				case "Grunner-Tasks":
					if (string === "next") {
						url = `grunner/tasks/all?nextToken=${nextPageToken}`;
					} else if (string === "prev") {
						url = `grunner/tasks/all?prevToken=${prevPageToken}`;
					} else if (string === "currentPageToken") {
						url = `grunner/tasks/all?currentToken=${currentPageToken}`;
					} else {
						url = `grunner/tasks/all`;
					}

					data = await getCRMData(token, url);

					await handleAPIResponse(data, selected);
					setShowActionBtn(true);

					break;
				case "Business-Users":
					if (string === "next") {
						url = `business/users/all?nextToken=${nextPageToken}`;
					} else if (string === "prev") {
						url = `business/users/all?prevToken=${prevPageToken}`;
					} else if (string === "currentPageToken") {
						url = `business/users/all?currentToken=${currentPageToken}`;
					} else {
						url = `business/users/all`;
					}

					data = await getCRMData(token, url);

					await handleAPIResponse(data, selected);
					setShowActionBtn(true);

					break;

				case "Business-Orders":
					if (string === "next") {
						url = `orders/business/all?nextToken=${nextPageToken}`;
					} else if (string === "prev") {
						url = `orders/business/all?prevToken=${prevPageToken}`;
					} else if (string === "currentPageToken") {
						url = `orders/business/all?currentToken=${currentPageToken}`;
					} else {
						url = `orders/business/all `;
					}

					data = await getCRMData(token, url);

					await handleAPIResponse(data, selected);
					setShowActionBtn(true);

					break;
				default:
					break;
			}
		} catch (error) {
			toast.error("Something went wrong, please try again later");
			setLoading(false);
			setData([]);
		}
	};

	const handleNextPage = () => {
		fetchDataBasedOnSelected(token, "next");
	};

	const handlePreviousPage = () => {
		fetchDataBasedOnSelected(token, "prev");
	};

	const handleFirstPage = () => {
		fetchDataBasedOnSelected(token);
	};

	const handleView = (data) => {
		console.log(data);
		if (selected === "Consumer-Orders") {
			let id = data["Order ID"];
			let type = data["Type"];
			let link = "";

			if (
				prevPageToken &&
				prevPageToken !== null &&
				prevPageToken !== undefined
			) {
				// link = `/logistics/crm/order-details?id=${id}&key=${selected}&nextPageToken=${prevPageToken}&path=${history?.location?.pathname}`;
				link = `/logistics/crm/order-details?id=${id}&type=${type}`;
			} else {
				// link = `/logistics/crm/order-details?id=${id}&path=${history?.location?.pathname}`;
				link = `/logistics/crm/order-details?id=${id}&type=${type}`;
			}

			window.open(link, "_blank");
		} else if (selected === "Merchant-Tasks" || selected === "Grunner-Tasks") {
			let id = data["Order ID"];
			let type = data["App Type"];
			let link = "";
			if (
				prevPageToken &&
				prevPageToken !== null &&
				prevPageToken !== undefined
			) {
				// link = `/logistics/crm/order-details?id=${id}&key=${selected}&nextPageToken=${prevPageToken}&path=${history?.location?.pathname}`;
				link = `/logistics/crm/order-details?id=${id}&type=${type}`;
			} else {
				// link = `/logistics/crm/order-details?id=${id}&path=${history?.location?.pathname}`;
				link = `/logistics/crm/order-details?id=${id}&type=${type}`;
			}

			window.open(link, "_blank");
		} else if (selected === "Consumer-Users") {
			let id = data["User ID"];
			let link = "";

			if (
				prevPageToken &&
				prevPageToken !== null &&
				prevPageToken !== undefined
			) {
				// link = `/logistics/crm/consumer-user?id=${id}&key=${selected}&nextPageToken=${prevPageToken}`;
				link = `/logistics/crm/consumer-user?id=${id}`;
			} else {
				// link = `/logistics/crm/consumer-user?id=${id}&key=${selected}`;
				link = `/logistics/crm/consumer-user?id=${id}`;
			}

			window.open(link, "_blank");
		} else if (selected === "Business-Users") {
			let id = data["User ID"];
			let link = "";

			if (
				prevPageToken &&
				prevPageToken !== null &&
				prevPageToken !== undefined
			) {
				link = `/logistics/crm/business-user?id=${id}`;
			} else {
				link = `/logistics/crm/business-user?id=${id}`;
			}

			window.open(link, "_blank");
		} else if (selected === "Business-Orders") {
			let id = data["Order ID"];
			let type = data["Type"];
			let link = "";

			if (
				prevPageToken &&
				prevPageToken !== null &&
				prevPageToken !== undefined
			) {
				// link = `/logistics/crm/order-details?id=${id}&key=${selected}&nextPageToken=${prevPageToken}&path=${history?.location?.pathname}`;
				link = `/logistics/crm/order-details?id=${id}&type=${type}`;
			} else {
				// link = `/logistics/crm/order-details?id=${id}&path=${history?.location?.pathname}`;
				link = `/logistics/crm/order-details?id=${id}&type=${type}`;
			}

			window.open(link, "_blank");
		}
	};
	return (
		<>
			<ToastContainer />
			<div className={styles.mainContainer}>
				{loading ? (
					<div className={styles.clipLoader}>
						<ClipLoader color="#000" size={50} />
					</div>
				) : (
					<>
						<div className={styles.headerContainer}>
							<ArrowBackIcon
								fontSize="large"
								style={{ marginLeft: "-5px", cursor: "pointer" }}
								onClick={handleGoBack}
							/>
							<div className={styles.titleContainer}>
								<div className={styles.pageTitle}>CRM</div>
							</div>
						</div>
						<div className={styles.dropDownContainer}>
							<div className={styles.dropDownContentContainer}>
								<button
									type="button"
									className={styles.dropDownBtn}
									onClick={toggleOptions}
									aria-haspopup="listbox"
									aria-expanded={isOptionsOpen}
								>
									<div className={styles.btnContent}>
										<span className="option-text-ph">
											{selected ? selected : "Select"}{" "}
										</span>
										{isOptionsOpen ? (
											<KeyboardArrowUpIcon
												viewBox="0 0 23 23"
												fontSize="small"
											/>
										) : (
											<ExpandMoreIcon viewBox="0 0 23 23" fontSize="small" />
										)}
									</div>
								</button>

								{isOptionsOpen ? (
									<ul
										role="listbox"
										tabIndex={-1}
										className={styles.ulContainer}
									>
										{crmContent?.map((entry) => {
											return (
												<Entry entry={entry} depth={1} key={entry?.title} />
											);
										})}
									</ul>
								) : null}
							</div>
						</div>
						<div>
							<DataTable
								data={data}
								onNextPage={handleNextPage}
								onPreviousPage={handlePreviousPage}
								onFirstPage={handleFirstPage}
								hasNextPage={hasNextPage}
								hasPrevPage={hasPrevPage}
								onView={handleView}
								showActionBtn={showActionBtn}
							/>
						</div>
					</>
				)}
			</div>
		</>
	);
}

export default CRM_Main_Page;
